import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const EmailVerifyPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const verifyToken = async () => {
      try {
        console.log('EmailVerifyPage: Verifying token:', token);
        
        if (!token) {
          setError('No token provided');
          setLoading(false);
          return;
        }
        
        // Redirect to backend verification endpoint
        window.location.href = `/api/v1/auth/email/verify/${token}`;
      } catch (err) {
        console.error('Error verifying email token:', err);
        setError('Failed to verify email token');
        setLoading(false);
      }
    };
    
    verifyToken();
  }, [token, navigate]);
  
  if (loading) {
    return (
      <div className="email-verify-page">
        <div className="loading-container">
          <h2>Verifying your email...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="email-verify-page">
        <div className="error-container">
          <h2>Verification Error</h2>
          <p className="error-message">{error}</p>
          <button 
            className="retry-button"
            onClick={() => navigate('/login')}
          >
            Return to Login
          </button>
        </div>
      </div>
    );
  }
  
  return null;
};

export default EmailVerifyPage;
